import React, { CSSProperties } from 'react';
import { Box, Center, Text } from '@mantine/core';
import { LucideIcon } from "lucide-react";

interface StatItemProps {
  icon: LucideIcon;
  value: number | string;
  label: string;
  style?: CSSProperties;
  iconStyle?: CSSProperties;
  valueStyle?: CSSProperties;
  labelStyle?: CSSProperties;
}

const StatItem: React.FC<StatItemProps> = ({
  icon: Icon, value, label, style, iconStyle, valueStyle, labelStyle,
}) => {
  return (
    <Box display="flex" style={{ flexDirection: 'column', alignItems: 'center', ...style }}>
      <Center w={32} h={32} style={{ borderRadius: '50%', backgroundColor: 'var(--mantine-primary-color-light)', color: 'var(--mantine-primary-color-filled)', ...iconStyle }}>
        <Icon size={16} />
      </Center>
      <Text size="xl" fw={700} mt="xs" style={valueStyle}>{value}</Text>
      <Text size="xs" c="dimmed" style={labelStyle}>{label}</Text>
    </Box>
  );
};

export default StatItem;
